import { ValidationErrors, Validators } from '@angular/forms';
import { mlpPhoneNumberValidator } from './phone.number/validators.phone.number';
import { mlpEmailValidator } from './email/validators.email';

export interface Validation {
    requirements: Array<ValidationErrors>;
    errorMessage: [string];
}

// Shared
export const V_EMAIL: Validation = {
    requirements: [Validators.required, mlpEmailValidator()],
    errorMessage: ['the field must contain a valid email address']
};

export const V_PHONE_NUMBER: Validation = {
    requirements: [Validators.required, mlpPhoneNumberValidator()],
    errorMessage: ['A phone number can only contain 0-9 + ( ) and minimum 7 characters']
};

// Sign up Form
export const V_FULL_NAME: Validation = {
    requirements: [Validators.required],
    errorMessage: ['This field is required']
};

export const V_PASSWORD: Validation = {
    requirements: [Validators.required],
    errorMessage: ['This field is required']
};

export const V_PASSWORD_REPEAT: Validation = {
    requirements: [Validators.required],
    errorMessage: ['This field needs to be the same as your password field']
};

// Guest Checkout
export const V_GUEST_CHECKOUT: Validation = {
    requirements: [],
    errorMessage: ['We need your details for your account and any bookings you make.']
};

export const V_GUEST_CHECKOUT_FULL_NAME: Validation = {
    requirements: [],
    errorMessage: ['This field is required']
};
